import axios from "@/index";
const area = {
  state: {
    provinceOptions: [],
    cityOptions: []
  },
  getters: {},
  actions: {
    getProvinceOptions: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setProvinceOptions",
                (state, { provinceOptions: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCityOptions: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setCityOptions", (state, { cityOptions: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setProvinceOptions(state, action) {
      state.provinceOptions = action.provinceOptions;
    },
    setCityOptions(state, action) {
      state.cityOptions = action.cityOptions;
    }
  }
};
export default area;
